import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const placeholder = css({
  padding: "10px",
  fontSize: "14px",
  marginRight: "auto",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  userSelect: "none",
});

export const imageContainer = css({
  height: 44,
  width: 44,
  flexShrink: 0,
  borderRadius: 6,
  overflow: "hidden",
  userSelect: "none",
});

export const drop =
  ({ isDragging }: { isDragging: boolean }) =>
  ({ colorsV2 }: ExactTheme) =>
    css({
      borderBottomLeftRadius: 6,
      borderTopLeftRadius: 6,
      position: "absolute",

      background: "white",
      padding: 0,
      border: 0,
      cursor: isDragging ? "grabbing" : "grab",

      display: "flex",
      left: 0,
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: 20,
      "border-right": `1px solid ${colorsV2.grey[100]}`,
    });

export const image = css({
  height: "100%",
  width: "100%",
  objectFit: "contain",
});

export const root =
  ({ isDragging }: { isDragging: boolean }) =>
  ({ colorsV2, inputBorderV2 }: ExactTheme) =>
    css({
      display: "flex",
      alignItems: "center",
      position: "relative",
      opacity: isDragging ? 0 : 1,
      gap: 5,
      height: 55,
      padding: 5,
      borderRadius: 6,
      cursor: isDragging ? "grabbing" : "pointer",
      border: inputBorderV2.transparent,
      willChange: "border, background",
      transition: "border 150ms, background 150ms",
      ".drop": {
        display: "none",
      },
      ":hover": {
        border: `1px solid ${colorsV2.grey[100]}`,
        backgroundColor: colorsV2.grey[25],
        ".drop": {
          display: "flex",
        },
      },
    });

export const removeButton = css({ flexShrink: 0 });
